import React from "react";
import styles from "../css/css_pages/Help.module.css";
import { FaVideo, FaFilePdf } from "react-icons/fa";

const Help = () => {
  return (
    <div className={styles.helpContainer}>
      {/* Help Page Title */}
      <h1 className={styles.mainTitle}>Help</h1>

      <div className={styles.sectionsContainer}>
        {/* Videos Section */}
        <div className={styles.helpSection}>
          <h2 className={styles.pageTitle}>Videos</h2>
          <div className={styles.helpContentVideos}>
            <div className={styles.videoCard}>
              <div className={styles.videoIcon}>
                <FaVideo size={40} color="#1C3663" />
              </div>
              <p>Add a little bit of body text</p>
            </div>
            <div className={styles.videoCard}>
              <div className={styles.videoIcon}>
                <FaVideo size={40} color="#1C3663" />
              </div>
              <p>Add a little bit of body text</p>
            </div>
          </div>
        </div>

        {/* PDFs Section */}
        <div className={styles.helpSection}>
          <h2 className={styles.pageTitle}>PDFs</h2>
          <ul className={styles.helpContentPdfs}>
            <li className={styles.pdfCard}>
              <div className={styles.pdfIcon}>
                <FaFilePdf size={30} color="#6F0A0C" />
              </div>
              <p>Add a little bit of body text</p>
            </li>
            <li className={styles.pdfCard}>
              <div className={styles.pdfIcon}>
                <FaFilePdf size={30} color="#6F0A0C" />
              </div>
              <p>Add a little bit of body text</p>
            </li>
            <li className={styles.pdfCard}>
              <div className={styles.pdfIcon}>
                <FaFilePdf size={30} color="#6F0A0C" />
              </div>
              <p>Add a little bit of body text</p>
            </li>
            <li className={styles.pdfCard}>
              <div className={styles.pdfIcon}>
                <FaFilePdf size={30} color="#6F0A0C" />
              </div>
              <p>Add a little bit of body text</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Help;
